import React from "react";
import { AiFillCloseCircle } from "react-icons/ai";

const ViewExpenseModal = ({ isOpen, onClose, data }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 p-2 flex items-center justify-center backdrop-blur-sm bg-black/50 bg-opacity-50">
      <div className="bg-white w-full h-[26rem] lg:h-fit overflow-y-auto lg:max-w-2xl p-6 rounded-lg shadow-lg relative">
        {/* Close Button */}
        <AiFillCloseCircle
          onClick={onClose}
          className="cursor-pointer text-primaryColor absolute top-4 right-4"
          size={30}
        />

        {/* Modal Title */}
        <h2 className="text-lg font-bold text-primaryTextColor mb-6 text-center">
          View Expense Details
        </h2>

        {/* Content */}
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          <div className="flex flex-col">
            <span className="font-semibold text-sm text-gray-400 ">Date:</span>
            <span className="text-sm text-primaryTextColor">
              {data?.date?.slice(0, 10)}
            </span>
          </div>

          <div className="flex flex-col">
            <span className="font-semibold text-sm text-gray-400 ">
              Building Name:
            </span>
            <span className="text-sm text-primaryTextColor">
              {data?.buildingName?.nameBuilding || "N/A"}
            </span>
          </div>

          <div className="flex flex-col">
            <span className="font-semibold text-sm text-gray-400">
              Category:
            </span>
            <span className="text-sm text-primaryTextColor">
              {data?.category}
            </span>
          </div>

          <div className="flex flex-col">
            <span className="font-semibold text-sm text-gray-400 ">
              Amount:
            </span>
            <span className="text-sm text-primaryTextColor">
              {data?.amount}
            </span>
          </div>

          <div className="flex flex-col">
            <span className="font-semibold text-sm text-gray-400 ">
              Attachment:
            </span>
            {data?.attachment ? (
              <a href={data?.attachment} target="_blank">
                <img
                  src={data?.attachment}
                  alt="attachment"
                  className="w-[40%] rounded-lg shadow-xl hover:scale-105 transition-all ease-in-out duration-300"
                />
              </a>
            ) : (
              <p className="text-sm text-primaryTextColor">N/A</p>
            )}
          </div>

          {/* Full-width Description */}
          <div className="flex flex-col ">
            <span className="font-semibold text-sm text-gray-400 ">
              Description:
            </span>
            <p className="text-sm text-primaryTextColor">{data?.description}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewExpenseModal;
